import React, { useCallback, useReducer } from "react";

const formReducer = (state, action) => {
  switch (action.type) {
    case "INPUT_CHANGE":
      let formIsValid = true;
      for (const inputId in state.inputs) {
        if (!state.inputs[inputId]) {
          continue;
        }
        if (inputId === action.inputId) {
          formIsValid = formIsValid && action.isValid;
        } else {
          formIsValid = formIsValid && state.inputs[inputId].isValid;
        }
      }
      return {
        ...state,
        inputs: {
          ...state.inputs,
          [action.inputId]: { value: action.value, isValid: action.isValid },
        },
        isValid: formIsValid,
      };
    case "SET_DATA":
      return {
        inputs: action.inputs,
        isValid: action.formIsValid,
      };
    case "RESET_FORM":
      console.log(
        "Resetting form",
        action.initialInputs,
        action.initialValidity
      );
      return {
        inputs: action.initialInputs,
        isValid: action.initialValidity,
      };

    default:
      return state;
  }
};

const useForm = (formInitialInputs, formInitialValidity) => {
  const [formState, dispatch] = useReducer(formReducer, {
    inputs: formInitialInputs,
    isValid: formInitialValidity,
  });

  const resetForm = useCallback(() => {
    dispatch({
      type: "RESET_FORM",
      initialInputs: formInitialInputs,
      initialValidity: formInitialValidity,
    });
  }, [formInitialInputs, formInitialValidity]);

  const setFormData = useCallback((inputData, formValidity) => {
    dispatch({
      type: "SET_DATA",
      inputs: inputData,
      formIsValid: formValidity,
    });
  }, []);

  const inputHandler = useCallback((id, value, isValid) => {
    dispatch({
      type: "INPUT_CHANGE",
      value: value,
      isValid: isValid,
      inputId: id,
    });
  }, []);

  return [formState, inputHandler, setFormData, resetForm];
};

export default useForm;
